import React, { useEffect, useRef, useState } from "react";
import { CSVReader } from "react-papaparse";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  TextInput,
  FlatList,
  ScrollView,
} from "react-native";
import { AntDesign, Entypo } from "@expo/vector-icons";
import { Modal } from "react-native-web";
import AddGroups from "./addGroups";
import Editgroups from "./editgroups";
import ManageGroups1 from "./manageGroups1";
import { useRecoilState, useRecoilValue } from "recoil";
import { univer, userState } from "../reducer";
import { useIsFocused } from "@react-navigation/native";
import { apiservice } from "../service/api";
import "./dragdrop.css";
const { width, height } = Dimensions.get("window");

const manageGroups = ({ setpages, states }) => {
  const [modal, setmodal] = useState(false);
  const [state, setstate] = useState({});
  const [university, setUniversity] = useRecoilState(univer);
  const [data1, setdata] = useState([]);
  const [page, setpage] = useState(0);
  const user = useRecoilValue(userState);
  const isFocus = useIsFocused();
  const buttonRef = useRef();
  const [fill, setfill] = useState("");

  const [error, seterror] = useState(false);

  const [valid, setvalid] = useState(false);
  const [valid1, setvalid1] = useState(false);
  const [datavalid, setdatavalid] = useState([]);
  const [datavalid1, setdatavalid1] = useState([]);
  const [datavalid2, setdatavalid2] = useState([]);

  // Drag and drop states
  const [draggedItem, setDraggedItem] = useState(null);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const [updateTimeout, setUpdateTimeout] = useState(null);

  async function getallUniversity() {
    const res = await apiservice({
      path: "/group/getall?university_id=" + user.university_id,
      method: "get",
    });
    if (res.status == 200) {
      setdata(res.data.result.filter((item) => item.associated == states.id));
    }
  }

  useEffect(() => {
    getallUniversity();
  }, [isFocus, page]);

  // Cleanup effect for drag events
  useEffect(() => {
    return () => {
      // Clear any pending timeout
      if (updateTimeout) {
        clearTimeout(updateTimeout);
      }
    };
  }, [updateTimeout]);

  // HTML5 Drag and Drop handlers
  const handleDragStart = (e, item, index) => {
    console.log('Drag started for item:', item.name, 'at index:', index);

    setDraggedItem(item);
    setDraggedIndex(index);

    // Set drag data
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/html', e.target.outerHTML);
    e.dataTransfer.setData('text/plain', item.id.toString());

    // Add visual feedback
    e.target.classList.add('dragging');
  };

  const handleDragEnd = (e) => {
    console.log('Drag ended');

    // Clean up
    e.target.classList.remove('dragging');
    setDraggedItem(null);
    setDraggedIndex(null);
    setDragOverIndex(null);

    // Remove visual feedback from all elements
    const rows = document.querySelectorAll('.draggable-row');
    rows.forEach(row => {
      row.classList.remove('drag-over');
    });
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDragEnter = (e, index) => {
    e.preventDefault();

    if (draggedIndex !== null && draggedIndex !== index) {
      setDragOverIndex(index);
      e.target.closest('.draggable-row')?.classList.add('drag-over');
    }
  };

  const handleDragLeave = (e) => {
    e.target.closest('.draggable-row')?.classList.remove('drag-over');
  };

  const handleDrop = async (e, dropIndex) => {
    e.preventDefault();
    e.stopPropagation();

    const targetRow = e.target.closest('.draggable-row');
    targetRow?.classList.remove('drag-over');

    if (draggedIndex === null || draggedIndex === dropIndex) {
      return;
    }

    console.log('Dropping at index:', dropIndex, 'from index:', draggedIndex);

    // Update array order
    await updateArrayOrder(dropIndex);
  };

  // Update array order during drag
  const updateArrayOrder = async (dropIndex) => {
    if (draggedIndex === null || draggedIndex === dropIndex) {
      return;
    }

    const filteredData = data1.filter((item) => item.name.includes(fill));
    const newData = [...filteredData];

    // Remove dragged item from its original position
    const draggedItemData = newData.splice(draggedIndex, 1)[0];

    // Insert it at the new position
    newData.splice(dropIndex, 0, draggedItemData);

    // Update the original data array to maintain order
    const updatedData = [...data1];
    const filteredIndexes = [];

    // Find indexes of filtered items in original data
    data1.forEach((item, index) => {
      if (item.name.includes(fill)) {
        filteredIndexes.push(index);
      }
    });

    // Update positions in the original data
    newData.forEach((item, newIndex) => {
      const originalIndex = filteredIndexes[newIndex];
      if (originalIndex !== undefined) {
        updatedData[originalIndex] = item;
      }
    });

    await Promise.all(updatedData.map(async (item, index) => {
      await apiservice({
        path: "/group/update",
        method: "put",
        body: { ...item, seq: index + 1 },
      });
    }))

    getallUniversity()

    // Update the dragged index to the new position
    setDraggedIndex(dropIndex);

    // Debounced server update to prevent too many API calls
    if (updateTimeout) {
      clearTimeout(updateTimeout);
    }

    const timeoutId = setTimeout(async () => {
      try {
        const orderData = newData.map((item, index) => ({
          id: item.id,
          sort_order: index + 1
        }));

        await apiservice({
          path: "/group/updateOrder",
          method: "put",
          body: { groups: orderData }
        });
        console.log("Order updated successfully");
      } catch (error) {
        console.log("Error updating order:", error);
      }
    }, 500); // Wait 500ms after last move before updating server

    setUpdateTimeout(timeoutId);
  };

  const revampFormatDate = (dateStr) => {
    const [day, month, year] = dateStr.split('-');

    // Return the date in yyyy-mm-dd format
    return `${year}-${month}-${day}`;
  }


  const handleOnFileLoad = async (data) => {
    const date = await Promise.all(
      data.map(async (item, index) => {
        //item.data["10"] != undefined)
        // console.log("AAA",item.data["7"]);
        if (index != 0) {
          try {
            const response = await apiservice({
              path: "/authen/createinfo",
              method: "POST",
              body: {
                firstname: item.data["0"],
                lastname: item.data["1"],
                nickname: item.data["2"],
                image_url: ["https://api.cquiz.app/api/image/get/user"],
                image_background_url: "",
                type: item.data["3"],
                position: item.data["4"],
                role: item.data["5"],
                birthday: revampFormatDate(item.data["6"]),
                tel_number: item.data["7"],
                address: item.data["8"],
                sort_order: item.data["9"],
                show_tel_number: true,
                show_address: true,
                university_id: user.university_id,
                group_id: state.id,
                email: ''
              },
            });

            if (item.data["7"].length == 0 || item.data["6"].length == 0) {
              seterror(true);
              setdatavalid1((val) =>
                val.concat(
                  item.data["0"] +
                  " " +
                  item.data["1"] +
                  " เบอร์โทร " +
                  item.data["7"]
                )
              );
            } else if (response.status == 200) {
              setdatavalid((val) =>
                val.concat(
                  item.data["0"] +
                  " " +
                  item.data["1"] +
                  " เบอร์โทร " +
                  item.data["7"]
                )
              );
              setvalid1(true);
            } else if (
              response.data.message ==
              "เบอร์โทรศัพท์ในมหาลัยนี้มีคนใช้งานแล้วกรุณาตรวจสอบ"
            ) {
              console.log("GGG", response.data);
              setdatavalid2((val) =>
                val.concat(
                  item.data["0"] +
                  " " +
                  item.data["1"] +
                  " เบอร์โทร " +
                  item.data["7"]
                )
              );
              setvalid(true);
            }
          } catch (error) {
            if (item.data["6"]?.length == 0) {
              seterror(true);
              setdatavalid1((val) =>
                val.concat(
                  item.data["0"] +
                  " " +
                  item.data["1"] +
                  " เบอร์โทร " +
                  item.data["7"]
                )
              );
            }
          }
        }
      })
    );
    getallUniversity();
    // const test = data1.map((item) => console.log(item));
  };

  const handleOnError = (err, file, inputElem, reason) => {
    console.log(err);
  };

  async function handleGenerateUrl(id) {
    const res = await apiservice({
      path: "/authen/university",
      method: "post",
      body: {
        universityId: university.id,
      },
    });

    if (res.status == 200) {
      const url = `https://app-mcon.asiaconnectth.com/createuniversity/${res.data.id}?group_id=${id}`;
      await navigator.clipboard.writeText(url);

      alert("URL copied to clipboard!");
    }
  }

  const handleOnRemoveFile = (data) => {
    console.log("---------------------------");
    console.log(data);
    console.log("---------------------------");
  };

  const handleOpenDialog = (e) => {
    if (buttonRef.current) {
      buttonRef.current.open(e);
    }
  };

  async function deleteUniversity() {
    const res = await apiservice({
      path: "/group/delete/" + state.id,
      method: "delete",
    });
    if (res.status == 200) {
      getallUniversity();
      setmodal(false);
    }
  }

  return (
    <View style={styles.container}>
      <Modal
        animationType="none"
        transparent={true}
        visible={valid}
        onRequestClose={() => {
          setvalid(!valid);
        }}
      >
        {valid && (
          <View
            style={{
              flex: 1,
              backgroundColor: "#000000bb",
              justifyContent: "center",
            }}
          >
            <View
              style={{
                width: width * 0.5,
                backgroundColor: "#fff",
                justifyContent: "center",
                alignSelf: "center",
                height: 700,
                padding: 20,
              }}
            >
              <Text
                style={[
                  styles.TextButton,
                  { color: "#ff0000", margin: 10, alignSelf: "center" },
                ]}
              >
                {"เบอร์โทรศัพท์ในองค์กรนี้มีคนใช้งานแล้วกรุณาตรวจสอบ"}
              </Text>
              <ScrollView>
                <View style={{ height: "100%" }}>
                  {datavalid2.map((item) => {
                    return (
                      <Text
                        style={[
                          styles.TextButton,
                          { color: "#ff0000", margin: 10, alignSelf: "center" },
                        ]}
                      >
                        {item}
                      </Text>
                    );
                  })}
                </View>
              </ScrollView>
              <View
                style={{
                  alignSelf: "center",
                  marginTop: 20,
                }}
              >
                <TouchableOpacity
                  onPress={() => {
                    setdatavalid2([]);
                    setdatavalid1([]);
                    setvalid(false);
                    seterror(false);
                  }}
                  style={{
                    width: 120,
                    height: 35,
                    borderWidth: 1,
                    overflow: "hidden",
                    borderColor: "#000",
                    borderRadius: 5,
                    justifyContent: "center",
                  }}
                >
                  <Text
                    style={{
                      fontFamily: "Prompt-Regular",
                      fontSize: 16,
                      alignSelf: "center",
                    }}
                  >
                    ปิด
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        )}
      </Modal>
      {valid == false && (
        <Modal
          animationType="none"
          transparent={true}
          visible={error}
          onRequestClose={() => {
            seterror(!error);
          }}
        >
          {error && (
            <View
              style={{
                flex: 1,
                backgroundColor: "#000000bb",
                justifyContent: "center",
              }}
            >
              <View
                style={{
                  width: width * 0.5,
                  backgroundColor: "#fff",
                  justifyContent: "center",
                  alignSelf: "center",
                  height: 700,
                  padding: 20,
                }}
              >
                <Text
                  style={[
                    styles.TextButton,
                    { color: "#ff0000", margin: 10, alignSelf: "center" },
                  ]}
                >
                  {"อัพโหลดข้อมูลไม่สำเร็จ"}
                </Text>
                <ScrollView>
                  <View style={{ height: "100%" }}>
                    {datavalid1.map((item) => {
                      return (
                        <Text
                          style={[
                            styles.TextButton,
                            {
                              color: "#ff0000",
                              margin: 10,
                              alignSelf: "center",
                            },
                          ]}
                        >
                          {item}
                        </Text>
                      );
                    })}
                  </View>
                </ScrollView>
                <View
                  style={{
                    alignSelf: "center",
                    marginTop: 20,
                  }}
                >
                  <TouchableOpacity
                    onPress={() => {
                      setdatavalid1([]);
                      seterror(false);
                    }}
                    style={{
                      width: 120,
                      height: 35,
                      borderWidth: 1,
                      overflow: "hidden",
                      borderColor: "#000",
                      borderRadius: 5,
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: "Prompt-Regular",
                        fontSize: 16,
                        alignSelf: "center",
                      }}
                    >
                      ปิด
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          )}
        </Modal>
      )}

      <Modal
        animationType="none"
        transparent={true}
        visible={valid1}
        onRequestClose={() => {
          setvalid1(!valid1);
        }}
      >
        {valid1 && (
          <View
            style={{
              flex: 1,
              backgroundColor: "#000000bb",
              justifyContent: "center",
            }}
          >
            <View
              style={{
                width: width * 0.5,
                backgroundColor: "#fff",
                justifyContent: "center",
                alignSelf: "center",
                height: 700,
                padding: 20,
              }}
            >
              <Text
                style={[
                  styles.TextButton,
                  { color: "black", margin: 10, alignSelf: "center" },
                ]}
              >
                {"อัพโหลดข้อมูลผู้ใช้งานมหาวิทยาลัยเรียบร้อย"}
              </Text>
              <ScrollView>
                <View style={{ height: "100%" }}>
                  {datavalid.map((item) => {
                    return (
                      <Text
                        style={[
                          styles.TextButton,
                          { color: "black", margin: 10, alignSelf: "center" },
                        ]}
                      >
                        {item}
                      </Text>
                    );
                  })}
                </View>
              </ScrollView>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignSelf: "center",
                  marginTop: 20,
                }}
              >
                <TouchableOpacity
                  onPress={() => {
                    setdatavalid([]);
                    setvalid1(false);
                  }}
                  style={{
                    width: 120,
                    height: 35,
                    borderWidth: 1,
                    overflow: "hidden",
                    borderColor: "#000",
                    borderRadius: 5,
                    justifyContent: "center",
                  }}
                >
                  <Text
                    style={{
                      fontFamily: "Prompt-Regular",
                      fontSize: 16,
                      alignSelf: "center",
                    }}
                  >
                    ปิด
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        )}
      </Modal>

      <Modal
        animationType="none"
        transparent={true}
        visible={modal}
        onRequestClose={() => {
          setmodal(!modal);
        }}
      >
        <View
          style={{
            width: width,
            height: height,
            backgroundColor: "#000000bb",
            justifyContent: "center",
          }}
        >
          <View
            style={{
              width: width * 0.5,
              height: height * 0.3,
              backgroundColor: "#fff",
              paddingHorizontal: 20,
              justifyContent: "center",
              alignSelf: "center",
            }}
          >
            <Text
              style={{
                fontSize: 18,
                fontFamily: "Prompt-Bold",
                color: "#202020",
                alignSelf: "center",
              }}
            >
              ต้องการลบข้อมูลนี้ใช่หรือไหม
            </Text>
            <View
              style={{
                width: width * 0.25,
                flexDirection: "row",
                justifyContent: "space-between",
                alignSelf: "center",
                marginTop: 20,
              }}
            >
              <TouchableOpacity
                onPress={() => setmodal(false)}
                style={{
                  width: 120,
                  height: 35,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#000",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: "Prompt-Regular",
                    fontSize: 16,
                    alignSelf: "center",
                  }}
                >
                  ยกเลิก
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  deleteUniversity();
                }}
                style={{
                  width: 120,
                  height: 35,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#000",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: "Prompt-Regular",
                    fontSize: 16,
                    alignSelf: "center",
                  }}
                >
                  ตกลง
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
      {page == 0 && (
        <View
          style={{
            width: width * 0.82,
            height: height * 0.9,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text
            style={{
              width: width * 0.591,
              fontSize: 18,
              fontFamily: "Prompt-Bold",
              color: "#202020",
            }}
          >
            {states.name}
          </Text>

          <Text
            style={{
              width: width * 0.591,
              fontSize: 12,
              fontFamily: "Prompt-Regular",
              color: "#666",
              marginBottom: 10,
            }}
          >
            💡 ลากที่ไอคอน ⋮⋮ เพื่อเรียงลำดับรายการ (Drag to reorder)
          </Text>

          <View
            style={{
              width: width * 0.591,
              height: height * 0.06,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <View
              style={{
                width: width * 0.235,
                height: height * 0.037,
                flexDirection: "row",
              }}
            >
              <TextInput
                defaultValue={fill}
                onChangeText={setfill}
                style={{
                  width: width * 0.8,
                  height: height * 0.037,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#00237740",
                  paddingLeft: 5,
                  fontFamily: "Prompt-Regular",
                  fontSize: 12,
                }}
              />
              <TouchableOpacity
                style={{
                  width: width * 0.022,
                  height: height * 0.037,
                  backgroundColor: "#002377",
                }}
              >
                <AntDesign
                  name="search1"
                  style={{ margin: "auto" }}
                  size={15}
                  color="#ffff"
                />
              </TouchableOpacity>
            </View>

            <TouchableOpacity
              onPress={() => setpage(1)}
              style={{
                width: width * 0.075,
                height: height * 0.037,
                backgroundColor: "#43A2D4",
                borderRadius: 5,
              }}
            >
              <Text style={styles.TextButton}>+ เพิ่มกลุ่ม</Text>
            </TouchableOpacity>
          </View>

          <View
            style={{
              width: width * 0.591,
              height: height * 0.546,
              borderWidth: 1,
              overflow: "hidden",
              borderColor: "#C2C2C2",
              borderTopLeftRadius: 5,
              borderTopRightRadius: 5,
            }}
          >
            <div
              style={{
                width: width * 0.591,
                height: height * 0.054,
                backgroundColor: "#002377",
                display: 'flex',
                flexDirection: "row",
                justifyContent: "space-around",
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
              }}
            >
              {/* Drag handle header */}
              <div style={{ width: 20, height: height * 0.054, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{
                  fontSize: 12,
                  color: "#FFF",
                  fontFamily: "Prompt-Regular"
                }}>

                </span>
              </div>

              <div style={{
                width: width * 0.103,
                height: height * 0.054,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <span style={{
                  fontSize: 20,
                  color: "#FFF",
                  fontFamily: "Prompt-Regular"
                }}>
                  ชื่อกลุ่ม
                </span>
              </div>

              <div style={{
                width: width * 0.095,
                height: height * 0.054,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <span style={{
                  fontSize: 20,
                  color: "#FFF",
                  fontFamily: "Prompt-Regular"
                }}>
                  สถานะ
                </span>
              </div>

              <div style={{
                width: width * 0.2,
                height: height * 0.054,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <span style={{
                  fontSize: 20,
                  color: "#FFF",
                  fontFamily: "Prompt-Regular"
                }}>
                  จัดการ
                </span>
              </div>
            </div>

            <div style={{ height: height * 0.492, overflowY: 'auto' }}>
              {data1.filter((item) => item.name.includes(fill)).map((item, index) => {
                const isCurrentlyDragging = draggedIndex === index;
                const isDropTarget = dragOverIndex === index;

                return (
                  <div
                    key={item.id || index}
                    data-row-index={index}
                    className={`draggable-row ${isDropTarget ? 'drag-over' : ''} ${isCurrentlyDragging ? 'dragging' : ''}`}
                    draggable={true}
                    onDragStart={(e) => handleDragStart(e, item, index)}
                    onDragEnd={handleDragEnd}
                    onDragOver={handleDragOver}
                    onDragEnter={(e) => handleDragEnter(e, index)}
                    onDragLeave={handleDragLeave}
                    onDrop={(e) => handleDrop(e, index)}
                    style={{
                      width: width * 0.591,
                      height: height * 0.06,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-around',
                      alignItems: 'center',
                      backgroundColor: isDropTarget
                        ? 'rgba(0, 35, 119, 0.1)'
                        : index % 2 == 0 ? "#ffffff" : "#E8E8E8",
                      opacity: isCurrentlyDragging ? 0.5 : 1,
                      transform: isCurrentlyDragging ? 'scale(1.02)' : 'scale(1)',
                      border: isDropTarget ? '2px dashed #002377' : 'none',
                      transition: isCurrentlyDragging ? 'none' : 'all 0.2s ease',
                      zIndex: isCurrentlyDragging ? 1000 : 1,
                      position: 'relative',
                      boxSizing: 'border-box',
                    }}
                  >
                    {/* Drag handle */}
                    <div
                      className="drag-handle"
                      style={{
                        width: 20,
                        height: height * 0.06,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(0, 35, 119, 0.2)',
                        cursor: 'grab',
                        userSelect: 'none',
                        padding: 0,
                      }}
                    >
                      <span style={{
                        color: '#002377',
                        fontSize: 14,
                        fontWeight: 'bold',
                        userSelect: 'none',
                        pointerEvents: 'none'
                      }}>
                        ⋮⋮
                      </span>
                    </div>

                    <div
                      style={{
                        width: width * 0.103,
                        height: height * 0.06,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pointerEvents: 'none', // Prevent drag interference
                      }}
                    >
                      <span style={{
                        fontSize: 16,
                        margin: "auto",
                        fontFamily: "Prompt-Regular"
                      }}>{item.name}</span>
                    </div>

                    <div
                      style={{
                        width: width * 0.095,
                        height: height * 0.06,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pointerEvents: 'none', // Prevent drag interference
                      }}
                    >
                      <span style={{
                        fontSize: 16,
                        margin: "auto",
                        fontFamily: "Prompt-Regular"
                      }}>
                        {item.status ? "ใช้งาน" : "ไม่ใช้งาน"}
                      </span>
                    </div>

                    <div
                      style={{
                        width: width * 0.2,
                        height: height * 0.06,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-evenly',
                        pointerEvents: 'auto', // Allow button interactions
                        gap: 4
                      }}
                    >
                      {!item.addgroup && (
                        <CSVReader
                          ref={buttonRef}
                          onFileLoad={handleOnFileLoad}
                          onError={handleOnError}
                          noClick
                          noDrag
                          onRemoveFile={handleOnRemoveFile}
                          noProgressBar={true}
                        >
                          {({ file }) => (
                            <button
                              onClick={(e) => {
                                setstate(item);
                                handleOpenDialog(e);
                              }}
                              style={{
                                width: 100,
                                height: 30,
                                borderRadius: 5,
                                backgroundColor: "#002377",
                                border: 'none',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              <span
                                style={{
                                  fontSize: 16,
                                  color: "#FFF",
                                  textAlign: "center",
                                  fontFamily: "Prompt-Regular"
                                }}
                              >
                                เพิ่มสมาชิก
                              </span>
                            </button>
                          )}
                        </CSVReader>
                      )}

                      {!item.addgroup && (
                        <button
                          onClick={() => {
                            handleGenerateUrl(item.id);
                          }}
                          style={{
                            width: 100,
                            height: 30,
                            borderRadius: 5,
                            backgroundColor: "#002377",
                            border: 'none',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <span
                            style={{
                              fontSize: 16,
                              color: "#FFF",
                              textAlign: "center",
                              fontFamily: "Prompt-Regular"
                            }}
                          >
                            คัดลอกลิงก์
                          </span>
                        </button>
                      )}

                      {item.addgroup && (
                        <button
                          onClick={() => {
                            setstate(item);
                            setpage(3);
                          }}
                          style={{
                            width: 70,
                            height: 30,
                            borderRadius: 5,
                            backgroundColor: "#FFF",
                            border: '1px solid #002377',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <span
                            style={{
                              fontSize: 16,
                              color: "#002377",
                              fontFamily: "Prompt-Regular"
                            }}
                          >
                            จัดการ
                          </span>
                        </button>
                      )}

                      <button
                        onClick={() => {
                          setstate(item);
                          setpage(2);
                        }}
                        style={{
                          width: 70,
                          height: 30,
                          borderRadius: 5,
                          backgroundColor: "#002377",
                          border: 'none',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <span style={{
                          fontSize: 16,
                          color: "#FFF",
                          fontFamily: "Prompt-Regular"
                        }}>แก้ไข</span>
                      </button>

                      <button
                        onClick={() => {
                          setstate(item);
                          setmodal(true);
                        }}
                        style={{
                          width: 70,
                          height: 30,
                          borderRadius: 5,
                          backgroundColor: "#D44343",
                          border: 'none',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <span style={{
                          fontSize: 16,
                          color: "#FFF",
                          fontFamily: "Prompt-Regular"
                        }}>ลบ</span>
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </View>
        </View>
      )}

      {page == 1 && <AddGroups setpages={setpage} associated={states.id} />}
      {page == 2 && <Editgroups setpages={setpage} state={state} />}
      {page == 3 && <ManageGroups1 setpages={setpage} states={state} />}
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#ffff",
  },
  Textheader: {
    fontSize: 20,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
  Textdata: { fontSize: 16, margin: "auto", fontFamily: "Prompt-Regular" },
  TextButton: {
    fontSize: 16,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
});
export default manageGroups;
